
import { Component, Vue } from 'vue-property-decorator';
import TicketContent from '@/views/pages/internal-tickets/TicketContent.vue';
import InternalTicketsRepositoryInterface, { Ticket } from '@/services/Internal-Tickets/interfaces';
import CommentComponent from '@/views/pages/internal-tickets/CommentComponent.vue';
import NoteComponent from '@/views/pages/internal-tickets/NoteComponent.vue';
import TicketInfo from '@/views/pages/internal-tickets/TicketInfo.vue';

@Component({
  components: { NoteComponent, CommentComponent, TicketInfo, TicketContent },
  inject: ['internalTicketsRepository'],
})
export default class TicketComponent extends Vue {
  private loading: boolean = true;
  public showDetails: boolean = true;
  public isQaVisible: boolean = false;
  public commentsVisible: boolean = false;

  private ticket: Ticket = {} as Ticket;
  private assignees: any[];
  public ticketId: string;
  public userId: string;
  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  private async created(): Promise<void> {
    this.ticketId = this.$route.params.ticketId;
    const vuex = JSON.parse(localStorage.getItem('vuex')!);
    this.userId = vuex.user.id;
    await this.initialize(Number(this.ticketId), this.userId);
    await this.checkIfUserIsQa();
    await this.isAbleToSeeComments();
    this.loading = false;
  }

  private async initialize(ticketId: number, userId: string): Promise<void> {
    this.ticket = await this.getTicketInfo(ticketId);
    this.assignees = await this.getAssignees();
  }

  private async checkIfUserIsQa() {
    const isQa = await this.assignees.find(assignee => assignee.userId === this.userId);
    if (isQa) {
      this.isQaVisible = true;
    }
  }

  private async isAbleToSeeComments() {
    if (this.ticket.assignee && this.ticket.assignee.userId === this.userId) {
      this.commentsVisible = true;
    }
    if (this.ticket.reporter && this.ticket.reporter === this.userId) {
      this.commentsVisible = true;
    }
  }


  private formatDate(timestamp: string) {
    const date = new Date(timestamp);
    return date.toLocaleString(); // returns a string in the format "4/4/2023, 3:04:36 PM" (based on the user's browser settings)
  }

  public toggleDetails() {
    this.showDetails = !this.showDetails;
  }

  private async getTicketInfo(id: number): Promise<Ticket> {
    try {
      return this.internalTicketsRepository.getTicketInfo(id);
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve features: ' + e.message);
      return {} as Ticket;
    }
  }

  private async getAssignees(): Promise<any> {
    try {
      return this.internalTicketsRepository.getAssignees();
    } catch (e) {
      this.$errorDialog.show('Failed to retrieve features: ' + e.message);
      return {} as Ticket;
    }
  }

  private async refresh(ticketId: string): Promise<void> {
    this.ticket = await this.getTicketInfo(Number(ticketId))
  }
}
